import BouncingSpinner from 'components/BouncingSpinner';
import BasicBlueprint from 'components/Icons/BasicBlueprint';
import { Button } from 'components/lib';
import React from 'react';
import { Punch } from 'records/Punch';
import { getPunchSnapshotUrl } from 'services/punchService';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  punch: Punch;
  label: string;
  sheetnumber: string;
  onClick: (projectId: string, sheetId: string, markupId: string) => void;
}

interface State {
  loaded: boolean;
  url: string;
}

const snapshotWidth = 420;
const snapshotHeight = 104;

class Snapshot extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loaded: false,
      url: '',
    };
    this.loadThumbnail();
  }

  handleClick = async (): Promise<void> => {
    const { sheetnumber, punch, onClick } = this.props;
    onClick(punch.projectid, sheetnumber, punch.markupids.first());
  };

  loadThumbnail = async (): Promise<void> => {
    const { punch } = this.props;
    const url = await getPunchSnapshotUrl(
      punch.projectid,
      punch.markupids.first(),
      snapshotWidth,
      104
    );
    this.setState({ loaded: true, url });
  };

  render(): React.ReactNode {
    const { url, loaded } = this.state;
    const { label } = this.props;
    return (
      <div
        className="flex-center su-column"
        onClick={this.handleClick}
        style={{
          cursor: 'pointer',
        }}
      >
        <Button
          id="punch-location-preview"
          variant="tertiary"
          style={
            !loaded
              ? {
                  position: 'relative',
                  left: '0px',
                  borderRadius: '8px',
                  border: 'solid 0.5px var(--light-grey-1)',
                  width: `${snapshotWidth}px`,
                  height: `${snapshotHeight}px`,
                  backgroundSize: 'cover',
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  overflow: 'hidden',
                }
              : {
                  position: 'relative',
                  left: '0px',
                  borderRadius: '8px',
                  border: 'solid 0.5px var(--light-grey-1)',
                  width: `${snapshotWidth}px`,
                  height: `${snapshotHeight}px`,
                  backgroundSize: 'cover',
                  background: `url(${url})`,
                  overflow: 'hidden',
                }
          }
        >
          {loaded ? (
            <p
              style={{
                position: 'absolute',
                bottom: '0',
                left: 0,
                fontSize: '12px',
                width: '100%',
                height: '35%',
                padding: '6px 25px',
                margin: '0',
                backgroundColor: 'rgba(255, 255, 255, .9)',
                textAlign: 'left',
              }}
            >
              {' '}
              <BasicBlueprint
                width="18px"
                height="18px"
                style={{
                  paddingBottom: '5px',
                }}
              />{' '}
              {label}
            </p>
          ) : (
            <div className="flex-center" style={{ width: '100%' }}>
              <BouncingSpinner />
            </div>
          )}
        </Button>
      </div>
    );
  }
}

export default withAppStore<Props>(Snapshot);
